@if (searchContainer.storedSearch.curStoredSearch) {
  <div class="search-focus-menu-panel dropdownIgnoreClicks"
       [ngClass]="{checked: searchContainer.storedSearch.curStoredSearch}"
  >
    <div class="search-focus-menu-panel__container">
      <a
        class="search-focus-menu-panel__close-focus-button"
        (click)="closeMenu()"
      >
        <mat-icon>
          navigate_before
        </mat-icon>

        <span>
          {{ 'TRANS__FOCUS__GO_BACK' | translate }}
        </span>
      </a>

      <div class="search-focus-menu-panel__top-section">
        <div class="search-focus-menu-panel__title">
          <span class="search-focus-menu-panel__title-text">
            <i class="icon-overview text-blue"></i>

            @if (!searchContainer.storedSearch.curStoredSearchId && !searchContainer.storedSearch.curStoredSearch.stored_search.name) {
              <span class="uppercase">
                {{ 'TRANS__FOCUS__INFO_SET_FOCUS_AS_NEW_SEARCH' | translate }}
              </span>
            }

            @if (searchContainer.storedSearch.curStoredSearch.stored_search.name) {
              <span class="uppercase">
                {{ '' | translate:{focusName: searchContainer.storedSearch.curStoredSearch.stored_search.name} }}
              </span>
            }
          </span>

          @if (searchContainer.storedSearch.curStoredSearchId) {
            <span class="search-focus-menu-panel__title-edit">
              <i
                class="icon-edit-alternative"
                (click)="editStoredSearch(searchContainer.storedSearch.curStoredSearch)"
                (keydown)="null"
              ></i>
            </span>
          }
        </div>

        <div class="search-focus-menu-panel__info">
          @if (!searchContainer.storedSearch.curStoredSearchId) {
            <span>
              {{ 'TRANS__FOCUS__INFO_SET_FOCUS' | translate }}
            </span>
          }

          @if (searchContainer.storedSearch.curStoredSearch.stored_search.stored && (hasChanges() && !dialogOpen)) {
            <span>
              <span>
                {{ 'TRANS__FOCUS__INFO_FOCUS_CHANGED_TO' | translate:{focusName: searchContainer.storedSearch.curStoredSearch.stored_search.name} }}
              </span>
            </span>
          }

          @if (storeMessage) {
            <span>
              <span>
                {{ storeMessage | translate:{focusName: searchContainer.storedSearch.curStoredSearch.stored_search.name} }}
              </span>
            </span>
          }
        </div>

        @if (searchContainer.storedSearch.curStoredSearchId) {
          <div class="search-focus-menu-panel__top-section-button-group">
            <a
              class="search-focus-menu-panel__top-section-button bg-primary"
              (click)="deselectStoredSearch()"
            >
              <span>
                {{'TRANS__FOCUS__BUTTON_LEAVE_FOCUS' | translate}}
              </span>
            </a>

            <div class="search-focus-menu-panel__top-section-button-group-separated">
              <a
                class="search-focus-menu-panel__top-section-button bg-primary"
                [ngClass]="{'disable-button bg-gray': !hasChanges() || dialogOpen ? 'disabled': undefined}"
                [attr.disabled]="!hasChanges() || dialogOpen ? 'disabled': undefined"
                (click)="storeStoredSearchChanges()"
              >
                <span>
                  {{ 'TRANS__FOCUS__BUTTON_STORE_CHANGES' | translate }}
                </span>
              </a>

              <a
                class="search-focus-menu-panel__top-section-button bg-gray"
                (click)="setStoredSearchAsNewSearch()"
              >
                <span>
                  {{ 'TRANS__FOCUS__BUTTON_STORE_AS_NEW_SEARCH' | translate }}
                </span>
              </a>
            </div>
          </div>
        }

        @if (!searchContainer.storedSearch.curStoredSearchId) {
          <div class="search-focus-menu-panel__top-section-button-no-focus">
            <a
              class="bg-primary"
              [ngClass]="{'no-stored-focuses': displayStoredSearches.length === 0}"
              (click)="setStoredSearchAsNewSearch()"
            >
              <span>
                {{ 'TRANS__FOCUS__BUTTON_STORE_AS_NEW_SEARCH' | translate }}
              </span>
            </a>
          </div>
        }
      </div>

      <div class="search-focus-menu-panel__get-focus">
        <a
          class="search-focus-menu-panel__get-focus-button"
          (click)="toggleSelectStoredSearchPanel()"
        >
          <span>
            {{ 'TRANS__FOCUS__SEARCH_SELECT_FOCUSES' | translate }}
          </span>

          <mat-icon>
            {{showSelectStoredSearchPanel ? 'expand_less' : 'expand_more'}}
          </mat-icon>
        </a>

        @if (showSelectStoredSearchPanel) {
          <div class="search-focus-menu-panel__search">
            <label for="selectFocus">
              <span>
                {{ 'TRANS__FOCUS__SEARCH_AFTER_FOCUSES' | translate }}
              </span>
            </label>

            <div class="clearInputContainer">
              <input
                type="text"
                id="selectFocus"
                placeholder="&#xe62c;&nbsp;{{'TRANS__FOCUS__SEARCH_AFTER_FOCUSES__PLACEHOLDER' | translate}}"
                [(ngModel)]="searchQuery"
                (ngModelChange)="inputChange()"
                autocomplete="off"
              >

              @if (searchQuery) {
                <a
                  class="clearInputField"
                  (click)="clearSearchInput()"
                >
                  <mat-icon>
                    close
                  </mat-icon>
                </a>
              }
            </div>

            <span>
              {{ 'TRANS__FOCUS__SELECT_FOCUSES' | translate }}
            </span>

            <div class="search-focus-menu-panel__search-options-container">
              <ul class="search-focus-menu-panel__search-options">
                @for (fo of displayStoredSearches; track $index) {
                  <li
                    [ngClass]="{'active': fo.stored_search.settingMenu}"
                    class="search-focus-menu-panel__search-option"
                  >
                    <span
                      class="search-focus-menu-panel__search-option-content"
                      [ngClass]="{'bold': fo.stored_search.settingMenu}"
                    >
                      <mat-radio-button
                        (click)="selectStoredSearch(fo)"
                        (keydown)="null"
                        [checked]="fo.stored_search.marked"
                        class="gray-radio-button search-focus-menu-panel__radio-button"
                      >
                        <span
                          [innerHTML]="getStoredSearchNameWeighedWordBreak(fo)"
                          class="search-focus-menu-panel__search-option-content-text"
                        ></span>

                        @if (fo.stored_search.isDefault) {
                          <span>
                            {{ 'TRANS__FOCUS__SELECT_FOCUSES__START_FOCUS' | translate }}
                          </span>
                        }
                      </mat-radio-button>

                      <span
                        class="search-focus-menu-panel__search-option-setting-button"
                        (click)="toggleSettingMenu(fo)"
                        (keydown)="null"
                      >
                        <mat-icon>
                          settings
                        </mat-icon>
                      </span>
                    </span>

                    @if (fo.stored_search.settingMenu) {
                      <span
                        class="search-focus-menu-panel__search-option-setting-menu"
                        [ngClass]="{'bold': fo.stored_search.settingMenu}"
                      >
                        <span
                          (click)="editStoredSearch(fo)"
                          (keydown)="null"
                        >
                          {{ 'TRANS__FOCUS__SELECT_FOCUSES__EDIT' | translate}}
                        </span>

                        <span class="search-focus-menu-panel__search-option-setting-menu-line"></span>

                        <span
                          (click)="delete(fo)"
                          (keydown)="null"
                        >
                          {{ 'TRANS__FOCUS__SELECT_FOCUSES__DELETE' | translate }}
                        </span>
                    </span>
                    }
                  </li>
                }
              </ul>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}

@if (searchContainer.storedSearch.curStoredSearch) {
  <div
    class="transparent-overlay"
    (click)="closeMenu()"
    (keydown)="null"
  ></div>
}
